import { Dictionary } from "@insite/client-framework/Common/Types";
import { IParseOptions, parse } from "qs";

type U = Dictionary<string>;

const getQueryString = <T>(locationSearch: string, options?: IParseOptions): Partial<T extends U ? U : T & U> => {
   return locationSearch
    ? (parse(locationSearch, { ignoreQueryPrefix: true, ...options }) as Partial<T extends U ? U : T & U>)
    : {};
};

export default getQueryString;
